var _circle, _circle2, _line, _path, _path2, _rect, _line2, _line3, _line4, _line5, _rect2, _rect3, _rect4, _circle3, _circle4, _path3, _path4, _ellipse, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestrictedView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 39.5,
    r: 4.5,
    fill: "none",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 39.5,
    r: 4.5,
    fill: "none",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 67,
    x2: 37,
    y2: 67,
    fill: "none",
    stroke: "#c4cefe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.36,15H63.91A6.12,6.12,0,0,1,70,21.14V53.86A6.12,6.12,0,0,1,63.91,60H9.09A6.12,6.12,0,0,1,3,53.86V21.14A6.12,6.12,0,0,1,9.09,15H29.36Z",
    fill: "#eff1ff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.36,20H68.91A6.12,6.12,0,0,1,75,26.14V58.86A6.12,6.12,0,0,1,68.91,65H14.09A6.12,6.12,0,0,1,8,58.86V26.14A6.12,6.12,0,0,1,14.09,20H34.36Z",
    fill: "#e3e7fe",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 25,
    width: 67,
    height: 45,
    rx: 6,
    ry: 6,
    fill: "#fff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 53,
    x2: 31,
    y2: 53,
    fill: "none",
    stroke: "#c4cefe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 53,
    x2: 41,
    y2: 53,
    fill: "none",
    stroke: "#c4cefe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 58,
    x2: 31,
    y2: 58,
    fill: "none",
    stroke: "#c4cefe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 58,
    x2: 41,
    y2: 58,
    fill: "none",
    stroke: "#c4cefe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 31,
    width: 4,
    height: 6,
    fill: "#c4cefe"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 31,
    width: 4,
    height: 6,
    fill: "#c4cefe"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 31,
    width: 4,
    height: 6,
    fill: "#c4cefe"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 60.5,
    r: 14.5,
    fill: "#fff",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 61,
    r: 11,
    fill: "#e3e7fe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70,59V57.52a3,3,0,0,1,6,0V59",
    fill: "none",
    stroke: "#6576ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.33,59h9.34A1.3,1.3,0,0,1,79,60.27v4.46A1.3,1.3,0,0,1,77.67,66H68.33A1.3,1.3,0,0,1,67,64.73V60.27A1.3,1.3,0,0,1,68.33,59Z",
    fill: "#6576ff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73,
    cy: 61.74,
    rx: 1.11,
    ry: 1.12,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5,62.38h1a0,0,0,0,1,0,0v1.5a.5.5,0,0,1-.5.5h0a.5.5,0,0,1-.5-.5v-1.5A0,0,0,0,1,72.5,62.38Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedView);
export default __webpack_public_path__ + "static/media/restricted-view.1a25f2f858bd9e4e161817340dd1eecc.svg";
export { ForwardRef as ReactComponent };